var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("pleaseChoose")
                  },
                  on: { change: _vm.envIdChange },
                  model: {
                    value: _vm.paramsData.env_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "env_id", $$v)
                    },
                    expression: "paramsData.env_id"
                  }
                },
                _vm._l(_vm.szgmEnv, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("serverChannel")
                  },
                  on: { change: _vm.serverChange },
                  model: {
                    value: _vm.server_channel,
                    callback: function($$v) {
                      _vm.server_channel = $$v
                    },
                    expression: "server_channel"
                  }
                },
                _vm._l(_vm.serverChannel, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("showTestServer")
                  },
                  on: { change: _vm.serverChannelChange },
                  model: {
                    value: _vm.show_test,
                    callback: function($$v) {
                      _vm.show_test = $$v
                    },
                    expression: "show_test"
                  }
                },
                _vm._l(_vm.serverType, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    filterable: "",
                    placeholder: _vm.$t("server")
                  },
                  on: { change: _vm.severChange },
                  model: {
                    value: _vm.paramsData.server_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "server_id", $$v)
                    },
                    expression: "paramsData.server_id"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.selectAll },
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("selectAll")))]
                  ),
                  _vm._l(_vm.serverListYJ, function(item) {
                    return _c("el-option", {
                      key: item.serverID,
                      attrs: { label: item.serverName, value: item.serverID }
                    })
                  })
                ],
                2
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  filterable: "",
                  placeholder: _vm.$t("playerId")
                },
                model: {
                  value: _vm.paramsData.uid,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "uid", $$v)
                  },
                  expression: "paramsData.uid"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-date-picker", {
                attrs: {
                  clearable: false,
                  "picker-options": _vm.pickerOptionsRadius,
                  "value-format": "timestamp",
                  type: "datetimerange",
                  "start-placeholder": _vm.$t("startTime"),
                  "end-placeholder": _vm.$t("endTime")
                },
                model: {
                  value: _vm.date,
                  callback: function($$v) {
                    _vm.date = $$v
                  },
                  expression: "date"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("scoreOperationType")
                  },
                  model: {
                    value: _vm.paramsData.score_type,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "score_type", $$v)
                    },
                    expression: "paramsData.score_type"
                  }
                },
                _vm._l(_vm.playList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("damageOperationType")
                  },
                  model: {
                    value: _vm.paramsData.damage_type,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "damage_type", $$v)
                    },
                    expression: "paramsData.damage_type"
                  }
                },
                _vm._l(_vm.playList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.exreqLoading,
                    disabled: !_vm.tableData.length
                  },
                  on: { click: _vm.exportdata }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addPlayer.open(2)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("modify")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "server_name", label: _vm.$t("serverName") }
          }),
          _c("el-table-column", {
            attrs: { prop: "role_id", label: _vm.$t("roleId") }
          }),
          _c("el-table-column", {
            attrs: { prop: "role_name", label: _vm.$t("roleName") }
          }),
          _c("el-table-column", {
            attrs: { prop: "score", label: _vm.$t("score") }
          }),
          _c("el-table-column", {
            attrs: { prop: "damage", label: _vm.$t("damage") }
          }),
          _c("el-table-column", {
            attrs: { prop: "score_type", label: _vm.$t("scoreOperationType") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.score_type == 1
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("increase")))])
                      : _vm._e(),
                    row.score_type == 2
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("deduct")))])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "damage_type",
              label: _vm.$t("damageOperationType")
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.damage_type == 1
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("increase")))])
                      : _vm._e(),
                    row.damage_type == 2
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("deduct")))])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "admin_name", label: _vm.$t("operatorUser") }
          }),
          _c("el-table-column", {
            attrs: { prop: "op_time", label: _vm.$t("time") }
          })
        ],
        1
      ),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total,sizes, prev, pager, next",
              "current-page": _vm.paramsData.page,
              total: _vm.total
            },
            on: { "current-change": _vm.getList, "size-change": _vm.sizeChange }
          })
        : _vm._e(),
      _c("addPlayer", {
        ref: "addPlayer",
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }